import { ChangeDetectionStrategy, Component, effect, inject, input, signal } from '@angular/core'
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { debounceTime, distinctUntilChanged } from 'rxjs'
import { DEBOUNCE_CONFIG } from '@app/config/DebounceConfig'
import { IconField } from 'primeng/iconfield'
import { InputIcon } from 'primeng/inputicon'
import { InputText } from 'primeng/inputtext'

@Component({
  selector: 'albert-search-bar',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, IconField, InputIcon, InputText],
  templateUrl: './search-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent {
  public readonly placeholder = input<string>('Search ...')
  public readonly debounceTimeMs = inject(DEBOUNCE_CONFIG)
  public searchInput = new FormControl('')
  public readonly searchInputSignal = signal(this.searchInput.value)

  constructor() {
    effect(() => {
      this.searchInput.valueChanges
        .pipe(debounceTime(this.debounceTimeMs ?? 300), distinctUntilChanged())
        .subscribe((res) => {
          this.searchInputSignal.set(res)
          console.warn('Performing search for:', res)
        })
    })
  }
}
